import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';

export default class AtendimentoAgricolaValidation extends DefaultValidation {

    /* Explicações do funcionamento do validation com MODULOPDA em PropriedadeValidation.js */
    constructor(msgs, modulopda) {
        super(msgs);

        if (modulopda && modulopda.detalhe) {
            let detalhe = {};
    
            modulopda.detalhe.forEach(d => {
                detalhe[d.campo] = d;
            });
    
            this.detalhe = detalhe;
        }
    }

    /**
     * validateFinalizar: valida o número de fotos e o RTR para poder finalizar
     */
    validate(model, refs, validateFinalizar = false) {
        let validated = true;
          /* Empresa não tem MODULOPDADETALHE mas é obrigatório */
        if (model.atendimento.empresa==null) {
            this.showMessage(new Message('error', 'msg-obrigatorio-empresa', true));
            refs.empresaSelect.focusedOut = true;
            validated = false;
        }
        
        /* Cliente não tem MODULOPDADETALHE mas é obrigatório, pois o atendimento está associado a um cliente */
        // if (model.atendimento.cliente==null) {
        //     this.showMessage(new Message('error', 'msg-obrigatorio-cliente', true));
        //     refs.clienteSelect.focusedOut = true;
        //     validated = false;
        // }
        
        /* Motivo atendimento */
        if (this.detalhe.MOTIVOATENDIMENTO && this.detalhe.MOTIVOATENDIMENTO.obrigainclusao && !this.detalhe.MOTIVOATENDIMENTO.oculta) {
            if (this.detalhe.MOTIVOATENDIMENTO.obrigainclusao && !model.atendimento.motivoAtendimento) {
                this.showMessage(new Message("error", "msg-obrigatorio-motivo", true));
                refs.motivoSelect.focusedOut = true;
                validated = false;
            }
        } else if (!this.detalhe.MOTIVOATENDIMENTO) {
            if (!model.atendimento.motivoAtendimento) {
                this.showMessage(new Message('error', 'msg-obrigatorio-motivo', true));
                refs.motivoSelect.focusedOut = true;
                validated = false;
            }
        }

        /* Propriedade */
        if (this.detalhe.PROPRIEDADE && this.detalhe.PROPRIEDADE.obrigainclusao && !this.detalhe.PROPRIEDADE.oculta && model.atendimento.propriedade==null) {
            this.showMessage(new Message("error", "msg-obrigatorio-propriedade", true));
            refs.propriedadeSelect.focusedOut = true;
            validated = false;
        }
        
        if (model.atendimento.motivoAtendimento!=null) {
            let obrigaContato       = model.atendimento.motivoAtendimento.obrigaContato || false;
            let obrigaObservacao    = model.atendimento.motivoAtendimento.obrigaObservacao || false;
            let minimoFotos         = model.atendimento.motivoAtendimento.minimoFotos || 0;
            let habilitaRtr         = model.atendimento.motivoAtendimento.habilitaRtr || true;
            let obrigaRtr           = model.atendimento.motivoAtendimento.obrigaRtr || false;
    
            if (obrigaContato && !model.atendimento.contato) {
                this.showMessage(new Message('error', 'msg-obrigatorio-contato', true));
                refs.contatoInput.focusedOut = true;
                validated = false;
            }
    
            if (obrigaObservacao && !model.atendimento.observacao) {
                this.showMessage(new Message('error', 'msg-obrigatorio-observacao', true));
                refs.obsTextArea.focusedOut = true;
                validated = false;
            }

            if (validateFinalizar) {
                if (model.fotos.length < minimoFotos) {
                    this.showMessage(new Message('error', 'msg-fotos-faltantes', true));
                    validated = false;
                }
    
                if (habilitaRtr && obrigaRtr && !model.atendimento.rtr) {
                    this.showMessage(new Message('error', 'msg-obrigatorio-agro-visita', true));
                    validated = false;
                }
    
                /*  Se RTR está habilitado, foi gerado e não finalizado, avisar
                    pois é obrigado a finalizar se gerou */
                if (habilitaRtr && model.atendimento.rtr && model.atendimento.rtr.situacao == 0) {
                    this.showMessage(new Message('error', 'msg-obrigatorio-finalizar-agro-visita', true));
                    validated = false;
                }
            }    
        }

        /* Data Atendimento */
        let atendimento = model.atendimento.dataAtendimento;
        if (this.detalhe.DATAATENDIMENTO && this.detalhe.DATAATENDIMENTO.obrigainclusao && !this.detalhe.DATAATENDIMENTO.oculta) {
            if (this.detalhe.DATAATENDIMENTO.obrigainclusao && !atendimento) {
                this.showMessage(new Message("error", "msg-obrigatorio-data", true));
                refs.dataAtendInput.focusedOut = true;
                validated = false;
            } else if (this.detalhe.DATAATENDIMENTO.obrigainclusao && atendimento) {
                let y = parseInt(atendimento.substr(0, 4) || 0);

                if (y < 1900 || y > 2200) {
                    this.showMessage(new Message('error', 'msg-data-atend-valida-1900-2200', true));
                    refs.dataAtendInput.focusedOut = true;
                    validated = false;
                }
            }
        } else if (!this.detalhe.DATAATENDIMENTO && atendimento) {
            let y = parseInt(atendimento.substr(0, 4) || 0);

            if (y < 1900 || y > 2200) {
                this.showMessage(new Message('error', 'msg-data-atend-valida-1900-2200', true));
                refs.dataAtendInput.focusedOut = true;
                validated = false;
            }
        }

        return validated;
    }

    validateRtr(model, refs) {
        let validated = true;

        /* Área */
        if (this.detalhe.RTR_AREA && this.detalhe.RTR_AREA.obrigainclusao && !this.detalhe.RTR_AREA.oculta && !model.area) {
            this.showMessage(new Message("error", "msg-obrigatorio-area", true));
            refs.areaSelect.focusedOut = true;
            validated = false;
        }

        /* Talhão */
        if (this.detalhe.RTR_TALHAO && this.detalhe.RTR_TALHAO.obrigainclusao && !this.detalhe.RTR_TALHAO.oculta && !model.talhao) {
            this.showMessage(new Message("error", "msg-obrigatorio-talhao", true));
            refs.talhaoSelect.focusedOut = true;
            validated = false;
        }

        /* Assunto */
        if (this.detalhe.RTR_ASSUNTO && this.detalhe.RTR_ASSUNTO.obrigainclusao && !this.detalhe.RTR_ASSUNTO.oculta && !model.assunto) {
            this.showMessage(new Message("error", "msg-obrigatorio-assunto-agro-visita", true));
            refs.assuntoSelect.focusedOut = true;
            validated = false;
        }

        /* Tipo */
        if (this.detalhe.RTR_TIPO && this.detalhe.RTR_TIPO.obrigainclusao && !this.detalhe.RTR_TIPO.oculta && !model.tipo) {
            this.showMessage(new Message("error", "msg-obrigatorio-tipo-agro-visita", true));
            refs.tipoRtrSelect.focusedOut = true;
            validated = false;
        }

        /* Cultura */
        if (this.detalhe.RTR_CULTURA && this.detalhe.RTR_CULTURA.obrigainclusao && !this.detalhe.RTR_CULTURA.oculta && !model.cultura) {
            this.showMessage(new Message("error", "msg-obrigatorio-cultura", true));
            refs.culturaSelect.focusedOut = true;
            validated = false;
        }

        /* Cultivar */
        if (this.detalhe.RTR_CULTIVAR && this.detalhe.RTR_CULTIVAR.obrigainclusao && !this.detalhe.RTR_CULTIVAR.oculta && !model.cultivar) {
            this.showMessage(new Message("error", "msg-obrigatorio-cultivo", true));
            refs.cultivarSelect.focusedOut = true;
            validated = false;
        }

        /* Fase Fenologica */
        if (this.detalhe.RTR_FASECULTIVO && this.detalhe.RTR_FASECULTIVO.obrigainclusao && !this.detalhe.RTR_FASECULTIVO.oculta && !model.faseFenologica) {
            this.showMessage(new Message("error", "msg-obrigatorio-fase-fenologica", true));
            refs.faseSelect.focusedOut = true;
            validated = false;
        }

        /* Data */
        if (this.detalhe.RTR_DATA && this.detalhe.RTR_DATA.obrigainclusao && !this.detalhe.RTR_DATA.oculta) {
            if (this.detalhe.RTR_DATA.obrigainclusao && !model.datahora) {
                this.showMessage(new Message("error", "msg-obrigatorio-data", true));
                refs.dataRtrInput.focusedOut = true;
                validated = false;
            } else if (this.detalhe.DATAATENDIMENTO.obrigainclusao && model.datahora) {
                let y = parseInt(model.datahora.substr(0, 4) || 0);

                if (y < 1900 || y > 2200) {
                    this.showMessage(new Message('error', 'msg-data-agro-visita-valida-1900-2200', true));
                    refs.dataRtrInput.focusedOut = true;
                    validated = false;
                }
            }
        } else if (!this.detalhe.RTR_DATA && model.datahora) {
            let y = parseInt(model.datahora.substr(0, 4) || 0);

            if (y < 1900 || y > 2200) {
                this.showMessage(new Message('error', 'msg-data-agro-visita-valida-1900-2200', true));
                refs.dataRtrInput.focusedOut = true;
                validated = false;
            }
        }

        return validated;
    }

}